import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the required CSS
import './style.css'
import { modules, formats } from "./Module";

const Editor = ({setContentState,dataForSendToApi,content,type}) => {

  const handleEditorChange = (contentData) => {
    // console.log(contentData);
    switch (type) {
      case 'DataInclusion':
        setContentState((prev)=>({...prev,productdescription:{...prev['productdescription'],inclusion:[contentData]}}));
        break;
      case 'DataExperience':
        setContentState((prev)=>({...prev,productdescription:{...prev['productdescription'],aboutexperience:contentData}}));
        break;
      case 'DataNeedToKnow':
        setContentState((prev)=>({...prev,productdescription:{...prev['productdescription'],need:contentData}}));
        break;
      case 'DataForCancellation':
        setContentState((prev)=>({...prev,productdescription:{...prev['productdescription'],cancellation:contentData}}));
        break;
      case 'DataTitleDesc':
        setContentState((prev)=>({...prev,productDetails:{...prev['productDetails'],producttitledescription:contentData}}));
        break;
      case 'content':
        setContentState((prev)=>({...prev,content:contentData}));
        break;  
      case 'Productcustomize':
        setContentState((prev)=>({ ...prev, productDescription: contentData }));
      break;
      default:
        setContentState((prev)=>({...prev,details:contentData}));//this is for static content module
        break;
    }
    };



  return (
    <div a> 
      <ReactQuill 
        theme="snow"
        value={content}
        onChange={handleEditorChange}
        modules={modules}
        formats={formats}
        placeholder="Write something awesome..."
      />
      {/* <div className="output">
        <h3>Editor Output:</h3>
        <div dangerouslySetInnerHTML={{ __html: value }} />
      </div> */}
    </div>
  );
};

export default Editor;
